import React from 'react';
import cx from 'classnames';
import Button from '../Button';
import './ButtonList.scss';

const ButtonList = (props) => {
  const { className, list, current, onClick, disabled } = props;

  return (
    <div className={cx('button-search', className)}>
      {list.map((item) => (
        <Button
          key={item.id}
          type="button"
          color={current === item.id ? 'primary' : 'light'}
          text={item.name}
          onClick={() => onClick(item)}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default ButtonList;
